import { Outlet } from '@remix-run/react';
import { useTypedRouteLoaderData } from 'remix-typedjson';
import LoginLayout from '#common/layouts/loginLayout.tsx';
import { type loader as rootLoader } from '#speaker-shop/root';

export default function Layout() {
    const { baseUrl } = useTypedRouteLoaderData<typeof rootLoader>('root')!;
    return (
        <div className='h-full w-full'>
            <LoginLayout title='Login' baseUrl={baseUrl}>
                <Outlet />
            </LoginLayout>
        </div>
    );
}
